<template>
    <PaymentModal :dataForPayment="dataForPayment" v-if="showModal" @close="dataForPayment = null; showModal = false;" />
</template>

<script>
import PaymentModal from '@/components/PaymentModal.vue'
import { bus } from '@/utils/bus.js'

export default {
    data() {
        return {
            dataForPayment: null,
            showModal: false,
        }
    },
    components: {
        PaymentModal
    },
    created() {
        bus.$on('showPaymentModal', dataForPayment => { this.dataForPayment = dataForPayment; this.showModal = true; });
    }
}
</script>
